import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import all from './all';
import bank from './bank';
import blocked from './blocked';
import notVerified from './notVerified';
import failed from './failed';
import paymentIds from "./paymentIds";
import idBase from "./idBase";

const Deposits = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/notVerified`}/>
      <Route path={`${match.url}/all`} component={all}/>
      <Route path={`${match.url}/bank`} component={bank}/>
      <Route path={`${match.url}/blocked`} component={blocked}/>
      <Route path={`${match.url}/notVerified`} component={notVerified}/>
      <Route path={`${match.url}/failed`} component={failed}/>
      <Route path={`${match.url}/idBase`} component={idBase}/>
      <Route path={`${match.url}/paymentIds`} component={paymentIds}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);
export default Deposits;
